import React from 'react';
import RegisterForm from './forms/RegisterForm';
import { connect } from 'react-redux';
import * as ROUTES from '../../constants/routes';
import { Redirect } from 'react-router-dom';

const RegistrationPage = (props) => {
    const { isSignedIn } = props;
    if (isSignedIn) {
        return <Redirect to={ROUTES.HOME_PROJECTS} />;
    }
    else {
        return (
            <div className="container-fluid container-form" >
                <RegisterForm />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        isSignedIn: !state.firebase.auth.isEmpty,
    }
}

export default connect(mapStateToProps)(RegistrationPage);